// src/redux/userList/userListSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';
// Thunk to fetch users
export const fetchUsers = createAsyncThunk('userList/fetchUsers', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${baseUrl}/users/list` // ✅ This properly interpolates baseUrl
, {
      withCredentials: true, // for cookies if auth-protected
    });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to fetch users');
  }
});

const userListSlice = createSlice({
  name: 'userList',
  initialState: {
    users: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Error fetching users';
      });
  },
});

export default userListSlice.reducer;
